import { ReactNode } from 'react';

import { Combobox } from '@base-ui/react/combobox';

import { IconReturn } from '@components/icons/return';
import { Tooltip } from '@components/tooltip';

import {
  EmptyMessage,
  FocusIconContainer,
  HelpText,
  OptionContainer,
  OptionLabel,
  ReturnHint,
} from './styles';

export const NoOptions = ({ children }: { children: ReactNode }) => {
  return (
    <Combobox.Empty>
      <EmptyMessage>{children}</EmptyMessage>
    </Combobox.Empty>
  );
};

type OptionContentProps = {
  label: ReactNode;
  helpText?: string;
  tooltip?: string;
  hasReturnHint?: boolean;
};

export const OptionContent = ({
  label,
  helpText,
  tooltip,
  hasReturnHint = false,
}: OptionContentProps) => {
  const body = (
    <OptionContainer $helpText={helpText}>
      <OptionLabel>{label}</OptionLabel>
      {helpText && <HelpText>{helpText}</HelpText>}
    </OptionContainer>
  );
  const row = hasReturnHint ? (
    <FocusIconContainer>
      {body}
      <ReturnHint>
        <IconReturn />
      </ReturnHint>
    </FocusIconContainer>
  ) : (
    body
  );

  return tooltip ? (
    <Tooltip placement="left" content={tooltip}>
      {row}
    </Tooltip>
  ) : (
    row
  );
};
